var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpLeaguesFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61589 0.46093L2.18691 3.37571C1.24083 4.511 0.767793 5.07865 0.983562 5.53933C1.19933 6 1.93824 6 3.41607 6L6.58393 6C8.06176 6 8.80067 6 9.01644 5.53933C9.23221 5.07865 8.75917 4.511 7.81309 3.37571L7.81309 3.37571L5.38411 0.46093C5.2061 0.247318 5.11709 0.140513 5 0.140513C4.88291 0.140513 4.7939 0.247318 4.61589 0.46093Z",
    fill: "#004EA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpLeaguesFavorite);
export default __webpack_public_path__ + "static/media/arrow_up_leagues_favorite.be9aa8f8c24f61eb2368a0ea547a2849.svg";
export { ForwardRef as ReactComponent };